import React, { Fragment, useState } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { ConfirmationModal } from "../../../../layout/Modal/ConfirmationModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUnlockAlt } from '@fortawesome/free-solid-svg-icons';
import { unlockUser as unlockUserApi } from "../../../../../api/clients/users";
import { Link } from "react-router-dom";
import { ACL } from "../../../../../config/constants";
import { NOTIFICATION_CLIENT_ACTIONS } from '../../../../../config/notifications';
import { store } from '../../../../../store/store';
import { hideNotification } from '../../../../../store/actions/notification';

function UnlockClient(props) {
  const [showLockModal, setShowLockModal] = useState(false);

  if (! ACL.CLIENT.USERS.LOCK.hasAccess()) {
    return null;
  }

  const {index, actionCallback, user, showIcon} = props;

  const unlockUser = () => {
    unlockUserApi({
      userId: user.id,
      notificationId: NOTIFICATION_CLIENT_ACTIONS
    }).then((response) => {
      setShowLockModal( false );

      if (response && response.status === 200) {
        actionCallback();
      }
    });
  };

  return (<Fragment>
      {!showIcon ?
        <Fragment>
          <Button
            color="primary"
            size="sm"
            className="btn-warning"
            type="button"
            id={`unlock-icon-${index}`}
            onClick={() => {
              store.dispatch(hideNotification());
              setShowLockModal(true)
            }}
          >
            <FormattedMessage
              id="components.pages.clients.table.actionButtons.unlock_user"/>
          </Button>
          <UncontrolledTooltip
            delay={0}
            target={`unlock-icon-${index}`}
            boundariesElement="viewport"
            positionFixed
          >
            <FormattedMessage
              id="components.pages.clients.table.actionButtons.unlock_user"/>
          </UncontrolledTooltip>
        </Fragment> :
        <Fragment>
          <Link
            to="#"
            className="cursor-pointer px-2 mx-2 link-icon-color"
            id={`unlock-icon-` + props.index}
            onClick={() => setShowLockModal(true)}
          >
            <FontAwesomeIcon
              size="lg"
              className="cursor-pointer"
              pointerEvents="none"
              icon={faUnlockAlt}
              fixedWidth
            />
          </Link>
          <UncontrolledTooltip
            delay={0}
            target={`unlock-icon-${props.index}`}
            boundariesElement="viewport"
            positionFixed
          >
            <FormattedMessage
              id="components.pages.clients.table.actionButtons.unlock_user"/>
          </UncontrolledTooltip>
        </Fragment>
      }

      <ConfirmationModal
        showModal={showLockModal}
        closeModal={() => setShowLockModal(false)}
        confirmationYes={unlockUser}
        messageId="components.layout.confirmation.body.unlock_user"
      />
    </Fragment>
  );
}

export { UnlockClient };
